<template>
  <div
    id="coachMain"
  >
    <MySchedules
      v-if="hasCoach"
      :policy-modal.sync="policyModal"
      :policy-agreed.sync="policyAgreed"
    />

    <CancellationPolicyModal
      v-if="policyModal"
      :show.sync="policyModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    MySchedules: () => import(/* webpackChunkName: "myCoach" */ './MySchedules.vue'),
    CancellationPolicyModal: () => import(/* webpackChunkName: "myCoach" */ '../coach/scheduler/CancellationPolicyModal.vue'),
  },

  data: () => ({
    policyModal: false,
  }),

  computed: {
    ...mapGetters('myCoach', {
      hasCoach: 'hasCoach',
    }),

    ...mapGetters('processStatus', {
      currentSession: 'currentSession',
    }),

    ...mapState({
      profile: (state) => state.user.profile,
    }),

    policyAgreed() {
      let flag = true;
      if (this.hasCoach && this.profile) {
        flag = this.profile.agreed_cancellation_policy;
      }
      return flag;
    },
  },

  watch: {
    hasCoach() {
      const mainScrollArea = document.getElementById('mainScrollArea');
      if (mainScrollArea) mainScrollArea.scrollTop = 0;
    },
  },

  mounted() {
    this.$EventBus.$on('open_policy_modal', () => {
      this.policyModal = true;
    });
  },
};
</script>
